module.exports = __webpack_public_path__ + "a10aaafa2d0ebf63ee34732540ebaa82.svg";